/* eslint-disable no-unused-vars */
import { LeaderboardState } from './leaderboard/types';

/**
 * @typedef {object} DraftTrackerState
 * @property {LeaderboardState} leaderboard
 */